import * as types from '../mutation-types'

const state = {
  loading: false
}

const getters = {
  loading: state => state.loading
}

const actions = {
}

const mutations = {
  [types.LOADER_LOADING] (state) {
    state.loading = true
  },

  [types.LOADER_NOT_LOADING] (state) {
    state.loading = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/loading.js